//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 24px 24px 0;
    gap: 24px;
    box-sizing: border-box;
    & > [data-role="button"] button {
        box-sizing: border-box;
        height: 40px;
        padding: 0 24px;
        font-size: 14px;
        line-height: 20px;
        white-space: nowrap;
    }
`;
export const Title = styled.h2`
    font-size: 20px;
    color: var(--dark-4);
    font-weight: 900;
    margin: 0;
    line-height: 32px;
    text-align: center;
`;
export const Student = styled.h3`
    background-color: #ECF4F9;
    border-radius: 8px;
    padding: 12px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
    text-align: center;
`;
export const Description = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: var(--dark-4);
    text-align: center;
`;
export const Adviser = styled.h4`
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    margin: 0;
    text-align: center;
`;
export const ScheduleCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    background-color: #ECF4F9;
    border-radius: 8px;
`;
export const ScheduleData = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    width: 100%;
`;
